import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AppsIcon from '@material-ui/icons/Apps';
import LocalLibraryIcon from '@material-ui/icons/Book';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { t } from 'ttag';
import { makeStyles } from '@material-ui/core/styles';
import useReactRouter from 'use-react-router';
import { useNavigator } from '../Navigator';
import useUser from '../../auth/hooks';
import { USER_PERMISSIONS, USER_TYPES } from '../../utils/enums';
import { SECTION_MAP, useMenuState } from './provider';
import { isIntersection } from '../../utils/helpers';
import router from '../../api/router';
import { canViewContributions, canViewDankai } from '../../utils/permissions';

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(6),
  },
  loginScreenButton: {
    backgroundColor: 'rgba(47,46,46,0.4)',
  },
}));

export const MenuList = () => {
  const classes = useStyles();
  const { match } = useReactRouter();
  const navigate = useNavigator();
  const { user } = useUser();
  const [open, onToggle] = useMenuState();
  const userse = ['/cabinet/managers', '/cabinet/trainers'];
  const structure = ['/cabinet/athletes', '/cabinet/gyms', '/cabinet/groups'];
  const functional = [
    '/cabinet/certifications_athlete',
    '/cabinet/certifications',
    '/cabinet/contributions',
    '/cabinet/statistics',
  ];
  const handleClick = (section) => {
    onToggle(section);
  };

  return (
    <div>
      <ListItem button onClick={() => navigate('/cabinet')}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary={t`Головна`} />
      </ListItem>
      {isIntersection(user.types, [
        USER_TYPES.superManager,
        USER_TYPES.manager,
      ]) &&
        (isIntersection(user.permissions, [USER_PERMISSIONS.read_trainers]) ||
          isIntersection(user.types, [USER_TYPES.superManager])) && (
          <>
            <ListItem button onClick={() => handleClick(SECTION_MAP.users)}>
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary={t`Користувачі`} />
              {open[SECTION_MAP.users] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={open[SECTION_MAP.users] || userse.includes(match.url)}
              timeout='auto'
              unmountOnExit
            >
              <List component='div' disablePadding className={classes.nested}>
                {user.types.includes(USER_TYPES.superManager) && (
                  <ListItem
                    className={
                      match.url === '/cabinet/managers'
                        ? classes.loginScreenButton
                        : ''
                    }
                    button
                    onClick={() => navigate(router.cabinet.managers.list())}
                  >
                    <ListItemText primary={t`Адміністратори`} />
                  </ListItem>
                )}
                {isIntersection(user.types, [
                  USER_TYPES.superManager,
                  USER_TYPES.manager,
                ]) &&
                  (isIntersection(user.permissions, [
                    USER_PERMISSIONS.read_trainers,
                  ]) ||
                    isIntersection(user.types, [USER_TYPES.superManager])) && (
                    <ListItem
                      className={
                        match.url === '/cabinet/trainers'
                          ? classes.loginScreenButton
                          : ''
                      }
                      button
                      onClick={() => navigate(router.cabinet.trainers.list())}
                    >
                      <ListItemText primary={t`Тренери`} />
                    </ListItem>
                  )}
              </List>
            </Collapse>
          </>
        )}
      {isIntersection(user.types, [
        USER_TYPES.superManager,
        USER_TYPES.manager,
        USER_TYPES.trainer,
      ]) &&
        (isIntersection(user.permissions, [
          USER_PERMISSIONS.read_gyms,
          USER_PERMISSIONS.read_athletes,
          USER_PERMISSIONS.read_groups,
        ]) ||
          isIntersection(user.types, [USER_TYPES.superManager])) && (
          <>
            <ListItem button onClick={() => handleClick(SECTION_MAP.structure)}>
              <ListItemIcon>
                <AccountTreeIcon />
              </ListItemIcon>
              <ListItemText primary={t`Структура`} />
              {open[SECTION_MAP.structure] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={open[SECTION_MAP.structure] || structure.includes(match.url)}
              timeout='auto'
              unmountOnExit
            >
              <List component='div' disablePadding className={classes.nested}>
                {isIntersection(user.types, [
                  USER_TYPES.superManager,
                  USER_TYPES.manager,
                ]) &&
                  (isIntersection(user.permissions, [
                    USER_PERMISSIONS.read_gyms,
                  ]) ||
                    isIntersection(user.types, [USER_TYPES.superManager])) && (
                    <ListItem
                      className={
                        match.url === '/cabinet/gyms'
                          ? classes.loginScreenButton
                          : ''
                      }
                      button
                      onClick={() => navigate(router.cabinet.gyms.list())}
                    >
                      <ListItemText primary={t`Зали`} />
                    </ListItem>
                  )}
                {isIntersection(user.types, [
                  USER_TYPES.superManager,
                  USER_TYPES.manager,
                  USER_TYPES.trainer,
                ]) &&
                  (isIntersection(user.permissions, [
                    USER_PERMISSIONS.read_athletes,
                  ]) ||
                    isIntersection(user.types, [
                      USER_TYPES.superManager,
                      USER_TYPES.trainer,
                    ])) && (
                    <ListItem
                      className={
                        match.url === '/cabinet/athletes'
                          ? classes.loginScreenButton
                          : ''
                      }
                      button
                      onClick={() => navigate(router.cabinet.athletes.list())}
                    >
                      <ListItemText primary={t`Спортсмени`} />
                    </ListItem>
                  )}
                {isIntersection(user.types, [
                  USER_TYPES.superManager,
                  USER_TYPES.manager,
                  USER_TYPES.trainer,
                ]) &&
                  (isIntersection(user.permissions, [
                    USER_PERMISSIONS.read_groups,
                  ]) ||
                    isIntersection(user.types, [USER_TYPES.superManager])) && (
                    <ListItem
                      className={
                        match.url === '/cabinet/groups'
                          ? classes.loginScreenButton
                          : ''
                      }
                      button
                      onClick={() => navigate(router.cabinet.groups.list())}
                    >
                      <ListItemText primary={t`Группи`} />
                    </ListItem>
                  )}
              </List>
            </Collapse>
          </>
        )}
      <ListItem button onClick={() => handleClick(SECTION_MAP.functional)}>
        <ListItemIcon>
          <AppsIcon />
        </ListItemIcon>
        <ListItemText primary={t`Функціонал`} />
        {open[SECTION_MAP.functional] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={open[SECTION_MAP.functional] || functional.includes(match.url)}
        timeout='auto'
        unmountOnExit
      >
        <List component='div' disablePadding className={classes.nested}>
          <ListItem
            className={
              match.url === '/cabinet/certifications' ||
              match.url === '/cabinet/certifications_athlete'
                ? classes.loginScreenButton
                : ''
            }
            button
            onClick={() => navigate(router.cabinet.certifications.list())}
          >
            <ListItemText primary={t`Атестації`} />
          </ListItem>
          {canViewContributions(user) && (
            <ListItem
              className={
                match.url === '/cabinet/contributions'
                  ? classes.loginScreenButton
                  : ''
              }
              button
              onClick={() => navigate(router.cabinet.contributions.list())}
            >
              <ListItemText primary={t`Членскі внески`} />
            </ListItem>
          )}
          {isIntersection(user.types, [USER_TYPES.superManager]) && (
            <ListItem
              className={
                match.url === '/cabinet/statistics'
                  ? classes.loginScreenButton
                  : ''
              }
              button
              onClick={() => navigate('/cabinet/statistics')}
            >
              <ListItemText primary={t`Статистика`} />
            </ListItem>
          )}
        </List>
      </Collapse>
      {canViewDankai(user) && (
        <ListItem
          className={
            match.url === '/cabinet/dankai'
              ? classes.loginScreenButton
              : ''
          }
          button
          onClick={() => navigate('/cabinet/dankai')}>
          <ListItemIcon>
            <LocalLibraryIcon />
          </ListItemIcon>
          <ListItemText primary={t`Данкай`} />
        </ListItem>
      )}
    </div>
  );
};

export default MenuList;
